import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import useTitle from "../../hooks/useTitle";
import request from "../../network/request";
import Button from "../../components/Button";
import useQuery from "../../hooks/useQuery";
import { ErrorPlaceholder } from "../../components/placeholder";
import LoadingHomepage from "../maintence/components/LoadingHomepage";
import MessageBox from "../../components/message-box";
import Loading from "../../components/loading";
import ShopList from "./components/shopList";
import SelectStoreCity from "./components/selectStoreCity";
import jsbridge from "@xpeng/js-bridge";
import useGetCh from "../../hooks/useGetCh";
import { reportUserBehavior } from "../../utils/report";

interface IAllProvinceAndCity {
  value: string; //省份编码
  label: string;
  children: { value: string; label: string }[];
}

interface IShop {
  code: string;
  distance: number;
  linkAddr: string;
  isUserDefaultShop: number;
  name: string;
}
interface IShopListParam {
  cityCode: number;
  lot: number | null;
  lat: number | null;
}

const initShop = {
  code: "",
  distance: -1,
  linkAddr: "",
  isUserDefaultShop: 0,
  name: "",
};

export default function ExclusiveStore() {
  useTitle("修改专属门店");
  const locationParams = useQuery();
  const vin = locationParams.get("vin");
  const ch = useGetCh();
  const [isLoading, setIsLoading] = useState(true);
  const [allDateShopList, setAllDateShopList] = useState<any[]>([]);
  const [allProvinceAndCity, setAllProvinceAndCity] = useState<
    IAllProvinceAndCity[]
  >([]);
  const [isError, setIsError] = useState(false);
  const [shopListParam, setShopListParam] = useState<IShopListParam>({
    cityCode: 0,
    lot: null,
    lat: null,
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [shopListMsg, setShopListErrorMsg] = useState("");
  const [locationMsg, setLocationMsg] = useState<any>({});
  const [selectedShop, setSelectedShop] = useState<IShop>(initShop);
  const [initialProvinceCity, setInitialProvinceCity] = useState<{
    province: string;
    city: string;
  }>({
    province: "",
    city: "",
  });
  const [provinceCityValue, setProvinceCityValue] = useState<{
    province: string;
    city: string;
  }>({
    province: "",
    city: "",
  });

  useEffect(() => {
    if (vin && vin.length === 17) {
      getProvinceAndCity();
      getLocation();
    } else {
      setIsError(true);
      setErrorMsg("vin码获取失败");
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    initShopList();
  }, [shopListParam]);

  useEffect(() => {
    if (
      allProvinceAndCity.length !== 0 &&
      locationMsg?.data?.coords?.longitude &&
      locationMsg?.data?.coords?.latitude
    ) {
      getCityWithLocation();
    }
  }, [allProvinceAndCity, locationMsg]);

  // 获取位置信息，优先从localStorage，没有再从定位中获取
  const getLocation = () => {
    let locationStorge: any = localStorage.getItem("__das_es_location");
    console.log(locationStorge, "获取locationStorge");
    if (locationStorge !== null && locationStorge !== "") {
      locationStorge = JSON.parse(locationStorge);
      let cityCode = locationStorge.cityCode;
      let province = locationStorge.province;
      let city = locationStorge.city;
      setShopListParam({
        cityCode,
        lot: null,
        lat: null,
      });
      setInitialProvinceCity({
        province,
        city,
      });
    } else {
      console.log("localStorage中没有值，获取定位");
      // 获取定位
      Loading.show();
      jsbridge.callHandler("requestLocation", {}).then((res) => {
        // 如果app端的定位在不允许下，需要手动抛出error(判断ios端res.code=2，Android端code=10)
        console.log(res, "手机原生定位信息");
        if (res?.data?.coords?.longitude && res?.data?.coords?.latitude) {
          setLocationMsg(res);
        } else {
          setShopListErrorMsg("请先选择城市");
          console.log(res.message, "获取定位失败");
          Loading.hide();
          reportUserBehavior({
            so: "J001006",
            mcode: "exclusive__req_location_error",
            pa: `vin=${vin}`,
            ch,
          });
        }
      });
    }
  };

  // 通过授权定位获取城市信息
  const getCityWithLocation = () => {
    // 使用经纬度判断是否授权成功
    const lot = locationMsg?.data?.coords?.longitude;
    const lat = locationMsg?.data?.coords?.latitude;
    const code = parseInt(locationMsg?.data?.adCode);
    const cityCode = Math.floor(code / 100) + "";
    const provinceCode = Math.floor(code / 10000) + "";
    let province = "";
    let city = "";
    let matchingCityCode: any = 0;
    allProvinceAndCity.forEach((provinceItem) => {
      if (provinceItem.value == provinceCode) {
        provinceItem.children.forEach((cityItem) => {
          // 兼容数据库中 上海 的citycode只有两位的情况
          if (cityItem.value == provinceCode) {
            matchingCityCode = provinceItem.value;
            city = cityItem.label;
            province = provinceItem.label;
          }
          if (cityItem.value == cityCode) {
            matchingCityCode = cityItem.value;
            city = cityItem.label;
            province = provinceItem.label;
          }
        });
      }
    });
    // 处理位置信息
    let tmp = {
      cityCode: matchingCityCode + "",
      province,
      city,
    };
    localStorage.setItem("__das_es_location", JSON.stringify(tmp));
    console.log(tmp, "存储定位获取的地址信息，localtionStorge");
    setShopListParam({
      cityCode: matchingCityCode,
      lot,
      lat,
    });
    setInitialProvinceCity({
      province: province,
      city: city,
    });
    reportUserBehavior({
      so: "J001006",
      mcode: "exclusive__req_location_success",
      pa: `vin=${vin}`,
      ch,
    });
  };
  // 获取服务省/城市列表
  const getProvinceAndCity = async () => {
    setIsLoading(true);
    try {
      const provinceAndCity: any = await request(
        "service/provinceCity/list",
        {},
        "POST"
      );
      console.log(provinceAndCity, "服务省/城市列表");
      setAllProvinceAndCity(provinceAndCity);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setIsError(true);
      console.log((err as any).message, "获取服务省/城市列表失败提示信息");
      setErrorMsg(
        (err as any).message || "获取服务省/城市列表失败，请稍后重试"
      );
    }
  };

  const initShopList = async () => {
    // 当省市loading结束之后才显示这种loading
    if (shopListParam.cityCode !== 0) {
      if (!isLoading) {
        Loading.show();
      }
      await getShopList();
      Loading.hide();
    }
  };
  // 获取门店列表
  const getShopList = async () => {
    try {
      const param = {
        cityCode: shopListParam.cityCode,
        vin: vin,
        lot: shopListParam.lot,
        lat: shopListParam.lat,
      };
      const shopList: IShop[] = await request(
        "service/shop/list",
        param,
        "POST"
      );
      console.log(shopList, "服务门店列表");
      if (shopList.length === 0) {
        setShopListErrorMsg("此城市暂无门店<br />请选择其他城市");
        setAllDateShopList(shopList);
        Loading.hide();

        reportUserBehavior({
          so: "J001006",
          mcode: "exclusive__req_shopList_empty",
          pa: `vin=${vin}\`cityCode=${shopListParam.cityCode}`,
          ch,
        });

        return;
      }
      reportUserBehavior({
        so: "J001006",
        mcode: "exclusive__req_shopList_success",
        pa: `vin=${vin}\`cityCode=${shopListParam.cityCode}`,
        ch,
      });
      // 如果含有专属门店，则默认选择已选门店
      shopList.forEach((shop) => {
        if (shop.isUserDefaultShop === 1) {
          setSelectedShop(shop);
        }
      });
      setAllDateShopList(shopList);
    } catch (err) {
      setShopListErrorMsg("门店列表获取失败，请稍后重试");
      MessageBox.toast(
        (err as any).message || "查询门店列表含门店容量失败，请稍后重试"
      );

      reportUserBehavior({
        so: "J001006",
        mcode: "exclusive__req_shopList_error",
        pa: `vin=${vin}\`cityCode=${shopListParam.cityCode}`,
        ch,
      });
    }
  };
  // 设为专属门店
  const handleConfirm = async () => {
    Loading.show();
    reportUserBehavior({
      so: "J001006",
      mcode: "exclusive__click_setting",
      pa: `vin=${vin}\`shopCode=${selectedShop.code}`,
      ch,
    });
    try {
      const res: any = await request(
        "user/default/shop/setting",
        {
          vin,
          shopCode: selectedShop.code,
        },
        "POST"
      );
      await getShopList();
      Loading.hide();
      MessageBox.toast("设置成功");
      // 处理位置信息
      let tmp = {
        cityCode: shopListParam.cityCode + "",
        province: provinceCityValue.province || initialProvinceCity.province,
        city: provinceCityValue.city || initialProvinceCity.city,
      };
      localStorage.setItem("__das_es_location", JSON.stringify(tmp));
      console.log(tmp, "存储localtionStorge");
      reportUserBehavior({
        so: "J001006",
        mcode: "exclusive__req_setting_success",
        pa: `vin=${vin}\`shopCode=${selectedShop.code}`,
        ch,
      });
    } catch (err) {
      Loading.hide();
      MessageBox.toast((err as any).message || "设为专属门店错误");
      reportUserBehavior({
        so: "J001006",
        mcode: "exclusive__req_setting_error",
        pa: `msg=${
          (err as any).message || "设为专属门店错误"
        }\`vin=${vin}\`shopCode=${selectedShop.code}`,
        ch,
      });
    }
  };
  // 将选择好的城市citycode返回并设置
  const handleConfirmCityCode = (obj) => {
    // 如果cityCode没有发生变化，不刷新
    if (shopListParam.cityCode !== obj.cityCode) {
      // 根据城市code获取服务门店列表
      setSelectedShop(initShop);
      setShopListParam({
        cityCode: obj.cityCode,
        lot: shopListParam.lot,
        lat: shopListParam.lat,
      });
      setProvinceCityValue({
        province: obj.province,
        city: obj.city,
      });
    }
  };

  const handleSelectShop = (shop) => {
    setSelectedShop(shop);
  };

  const reloadData = async () => {
    await getProvinceAndCity();
  };

  if (isLoading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (isError) {
    reportUserBehavior(
      {
        so: "J001006",
        mcode: "exclusive",
        pa: `status=error\`vin=${vin}`,
        ch,
      },
      "page"
    );

    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={reloadData}
      ></ErrorPlaceholder>
    );
  } else {
    reportUserBehavior(
      {
        so: "J001006",
        mcode: "exclusive",
        pa: `event=success\`vin=${vin}`,
        ch,
      },
      "page"
    );
  }
  return (
    <div className={styles.storeWrapper}>
      <SelectStoreCity
        allProvinceAndCity={allProvinceAndCity}
        initialProvinceCity={initialProvinceCity}
        handleConfirm={(cCode) => {
          handleConfirmCityCode(cCode);
        }}
      />
      <div>
        <ShopList
          allShopList={allDateShopList}
          tip={shopListMsg}
          selectedShop={selectedShop}
          onSelectShop={(item) => handleSelectShop(item)}
        />
        {allDateShopList?.length > 0 ? (
          <Button
            disabled={!selectedShop.code}
            fixed={true}
            onClick={handleConfirm}
          >
            <span>设为专属门店</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
}
